<template>
  <div class="table-wrapper">
    <h2 id="OPSummaryTitle" v-if="title"> {{ title }} </h2>
    <table class="hiaTable">
      <thead>
        <tr>
          <th style="width: 190px;"> </th>
          <th> Total APC </th>
          <th> APC w/o Query Rec. </th>
          <th> Total Codes </th>
          <th> ICD-10 CM Codes </th>
          <th v-if="tenantSetup.enableOutpatientPcsAuditing"> ICD-10 PCS Codes </th>
          <th> CPT Codes </th>
          <th> Modifier Codes </th>
          <th> EM Codes </th>
          <th> I&I Codes </th>
          <th> S&I Codes </th>
        </tr>
      </thead>
      <template v-if="item.totalRecords">
        <tr style="background-color: #FAFAFA;">
          <td class="strong titleCol textAlignLeft"> Total Reviewed </td>
          <td> {{item.apcTotalReviewed}} </td>
          <td> {{item.apcTotalReviedwoQuery}} </td>
          <td> {{item.totalCodesReviewed}} </td>
          <td> {{item.dxTotalReviewed}} </td>
          <td v-if="tenantSetup.enableOutpatientPcsAuditing"> {{item.pxTotalReviewed}} </td>
          <td> {{item.cptTotalReviewed}} </td>
          <td> {{item.modTotalReviewed}} </td>
          <td> {{item.emTotalReviewed}} </td>
          <td> {{item.iiTotalReviewed}} </td>
          <td> {{item.siTotalReviewed}} </td>
        </tr>

        <tr>
          <td class="strong titleCol textAlignLeft"> Total Recommendations </td>
          <td> {{item.apcTotalRec}} </td>
          <td> {{item.totalAPCRecwoQuery}} </td>
          <td> {{item.totalCodesRecommended}} </td>
          <td> {{item.dxTotalRec}} </td>
          <td v-if="tenantSetup.enableOutpatientPcsAuditing"> {{item.pxTotalRec}} </td>
          <td> {{item.cptTotalRec}} </td>
          <td> {{item.modTotalRec}} </td>
          <td> {{item.emTotalRec}} </td>
          <td> {{item.iiTotalRec}} </td>
          <td> {{item.siTotalRec}} </td>
        </tr>

        <tr style="background-color: #FAFAFA;">
          <td class="strong titleCol textAlignLeft"> No Recommendations </td>
          <td> {{item.apcNoRec}} </td>
          <td> {{item.apcNoRec}} </td>
          <td> {{item.totalCodesNoRec}} </td>
          <td> {{item.dxNoRec}} </td>
          <td v-if="tenantSetup.enableOutpatientPcsAuditing"> {{item.pxNoRec}} </td>
          <td> {{item.cptNoRec}} </td>
          <td> {{item.modNoRec}} </td>
          <td> {{item.emNoRec}} </td>
          <td> {{item.iiNoRec}} </td>
          <td> {{item.siNoRec}} </td>
        </tr>

        <tr>
          <td class="strong titleCol textAlignLeft"> Additions </td>
          <td> {{item.apcAdditions}} </td>
          <td> {{item.apcAdditions_WoQuery}} </td>
          <td> {{item.totalCodesAdditions}} </td>
          <td>{{item.dxAdditions}} </td>
          <td v-if="tenantSetup.enableOutpatientPcsAuditing">{{item.pxAdditions}} </td>
          <td>{{item.cptAdditions}} </td>
          <td>{{item.modAdditions}} </td>
          <td>{{item.emAdditions}} </td>
          <td>{{item.iiAdditions}} </td>
          <td>{{item.siAdditions}} </td>
        </tr>

        <tr style="background-color: #FAFAFA;">
          <td class="strong titleCol textAlignLeft"> Deletions </td>
          <td> {{item.apcDeletions}} </td>
          <td> {{item.apcDeletions_Woquery}} </td>
          <td> {{item.totalCodesDeletions}} </td>
          <td> {{item.dxDeletions}} </td>
          <td v-if="tenantSetup.enableOutpatientPcsAuditing"> {{item.pxDeletions}} </td>
          <td> {{item.cptDeletions}} </td>
          <td> {{item.modDeletions}} </td>
          <td> {{item.emDeletions}} </td>
          <td>{{item.iiDeletions}} </td>
          <td>{{item.siDeletions}} </td>
        </tr>

        <tr>
          <td class="strong titleCol textAlignLeft"> Revisions </td>
          <td> {{item.apcRevisions}} </td>
          <td> {{item.apcRevisions_Woquery}} </td>
          <td> {{item.totalCodesRev}} </td>
          <td> {{item.dxRevisions}} </td>
          <td v-if="tenantSetup.enableOutpatientPcsAuditing"> {{item.pxRevisions}} </td>
          <td> {{item.cptRevisions}} </td>
          <td> {{item.modRevisions}} </td>
          <td> {{item.emRevisions}} </td>
          <td>{{item.iiRevisions}} </td>
          <td>{{item.siRevisions}} </td>
        </tr>

        <tr style="background-color: #FAFAFA;">
          <td class="strong titleCol textAlignLeft"> Accuracy Rate </td>
          <td> {{ !item.apcTotalReviewed ? 'N/A' : formatPercentage(item.apcCodes) }} </td>
          <td> {{ !item.apcTotalReviedwoQuery ? 'N/A' : formatPercentage(item.apcCodeswoQuery) }} </td>
          <td> {{ !item.totalCodesReviewed ? 'N/A' : formatPercentage(item.totalCodes) }} </td>
          <td> {{ !item.dxTotalReviewed ? 'N/A' : formatPercentage(item.cmCodes) }} </td>
          <td v-if="tenantSetup.enableOutpatientPcsAuditing"> {{ !item.pxTotalReviewed ? 'N/A' : formatPercentage(item.pcsCodes) }} </td>
          <td> {{ !item.cptTotalReviewed ? 'N/A' : formatPercentage(item.cptCodes) }} </td>
          <td> {{ !item.modTotalReviewed ? 'N/A' : formatPercentage(item.modCodes) }} </td>
          <td> {{ !item.emTotalReviewed ? 'N/A' : formatPercentage(item.emCodes) }} </td>
          <td> {{ !item.iiTotalReviewed ? 'N/A' : formatPercentage(item.iiCodes) }} </td>
          <td> {{ !item.siTotalReviewed ? 'N/A' : formatPercentage(item.siCodes) }} </td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import money from '@/mixins/money'
  import dashboardHelper from '@/mixins/dashboardHelper'
  export default {
    name: 'IPBasicSummary',
    props: ['item', 'title'],
    mixins: [money, dashboardHelper],
    data: function () {
      return {
      }
    },
    methods: {},
    computed: {
      ...mapState('managedLists/tenantSetup/', ['tenantSetup'])
    }
  }
</script>

<style scoped>
  .hiaTable thead th {
    text-align: center;
  }

  .hiaTable tr td {
    text-align: right;
  }
</style>
